const templates = {
  'aec29a2a-b5e3-4b3f-853a-cd7b38892e27': {
    id: 1,
    uid: 'aec29a2a-b5e3-4b3f-853a-cd7b38892e27',
    description: 'A template designed to display image assets',
    name: 'image',
    multi: true,
    display_name: 'Image',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-image-area',
    src_file: 'Image.vzs',
    extra_info: {
      nested_template: false,
    },
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.File': {
        value: null,
        name: '.File',
        mode: 'RW',
        label: 'File',
        description: 'File',
        type: 'asset',
        asset_tag_filter: 'Image',
        init: true,
      },
      '.Saturation': {
        value: '100',
        name: '.Saturation',
        label: 'Saturation',
        mode: 'RW',
        description: 'Saturation',
        type: 'slider',
        min: '0',
        max: '1000',
        init: true,
      },
      '.Lift': {
        value: '0',
        name: '.Lift',
        label: 'Lift',
        mode: 'RW',
        description: 'Lift',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Gain': {
        value: '100',
        name: '.Gain',
        label: 'Gain',
        mode: 'RW',
        description: 'Gain',
        type: 'slider',
        min: '0',
        max: '1000',
        init: true,
      },
      '.SizeMode': {
        value: 'Fit',
        name: '.SizeMode',
        mode: 'RW',
        label: 'Size Mode',
        description: 'Size Mode',
        options: ['Stretch', 'Crop', 'Fit'],
        type: 'enum',
        init: true,
      },
      '.Underscan': {
        value: '100',
        name: '.Underscan',
        label: 'Underscan',
        mode: 'RW',
        description: 'Underscan',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Align': {
        value: 'Center',
        name: '.Align',
        mode: 'RW',
        label: 'Align',
        description: 'Align',
        options: ['Center', 'LeftTop', 'RightBottom'],
        type: 'enum',
        init: true,
      },
      '.Orientation': {
        value: 'Normal',
        name: '.Orientation',
        mode: 'RW',
        label: 'Orientation',
        description: 'Orientation',
        options: [
          'Normal',
          'FlipVertical',
          'Rotate180',
          'FlipHorizontal',
          'MirrorDownwardDiagonal',
          'RotateCW',
          'MirrorUpwardDiagonal',
          'RotateCCW',
        ],
        type: 'enum',
        init: true,
      },
      '.BackgroundColor': {
        value: '#000000',
        name: '.BackgroundColor',
        mode: 'RW',
        label: 'Background Color',
        description: 'Background Color',
        type: 'color',
        init: true,
      },
      '.BackgroundOpacity': {
        value: '100',
        name: '.BackgroundOpacity',
        label: 'Background Opacity',
        mode: 'RW',
        description: 'Background Opacity',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Blocked': {
        value: false,
        name: '.Blocked',
        mode: 'RW',
        label: 'Blocked',
        description: 'Blocked',
        type: 'bool',
        init: false,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [
      {
        name: 'Timer',
        uid: 'c582c08d-e845-4fb2-8ee8-beef434ba960',
        default_condition: true,
        data: {
          duration: {
            value: 10,
            label: 'Duration (Seconds)',
            type: 'float',
            dynamic: false,
          },
        },
        description: 'Valid while time since start is less than value',
        icon: 'mdi-timer',
        script: 'default_conditions.playback_timer',
        rejects: ['queue'],
      },
    ],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      'b3e7ad48-3ea5-4e15-bf63-d6d430903fc1',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  'e618870e-99b7-4a91-8e9e-2503c7ee6e24': {
    id: 2,
    extra_info: {
      nested_template: false,
    },
    uid: 'e618870e-99b7-4a91-8e9e-2503c7ee6e24',
    description: 'A template designed to play video assets',
    name: 'video',
    multi: true,
    display_name: 'Video',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-movie-open',
    src_file: 'Video.vzs',
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.File': {
        value: null,
        name: '.File',
        mode: 'RW',
        label: 'File',
        description: 'File',
        type: 'asset',
        asset_tag_filter: 'Video',
        init: true,
      },
      '.Pause': {
        value: null,
        name: '.Pause',
        label: 'Pause',
        mode: 'W',
        description: 'Pause',
        type: 'trigger',
        init: false,
      },
      '.Play': {
        value: true,
        name: '.Play',
        mode: 'W',
        label: 'Play',
        description: 'hint:auto_trigger',
        type: 'trigger',
        init: false,
      },
      '.Restart': {
        value: true,
        name: '.Restart',
        mode: 'W',
        label: 'Restart',
        description: 'hint:auto_trigger',
        type: 'trigger',
        init: false,
      },
      '.Audio': {
        value: true,
        name: '.Audio',
        mode: 'RW',
        label: 'Audio',
        description: 'Audio',
        type: 'bool',
        init: true,
      },
      '.Volume': {
        value: '100',
        name: '.Volume',
        label: 'Volume',
        mode: 'RW',
        description: 'Volume',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Loop': {
        value: false,
        name: '.Loop',
        mode: 'RW',
        label: 'Loop',
        description: 'Loop',
        type: 'bool',
        init: true,
      },
      '.SizeMode': {
        value: 'Fit',
        name: '.SizeMode',
        mode: 'RW',
        label: 'Size Mode',
        description: 'Size Mode',
        options: ['Stretch', 'Crop', 'Fit'],
        type: 'enum',
        init: true,
      },
      '.Underscan': {
        value: '100',
        name: '.Underscan',
        label: 'Underscan',
        mode: 'RW',
        description: 'Underscan',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Align': {
        value: 'Center',
        name: '.Align',
        mode: 'RW',
        label: 'Align',
        description: 'Align',
        options: ['Center', 'LeftTop', 'RightBottom'],
        type: 'enum',
        init: true,
      },
      '.Orientation': {
        value: 'Normal',
        name: '.Orientation',
        mode: 'RW',
        label: 'Orientation',
        description: 'Orientation',
        options: [
          'Normal',
          'FlipHorizontal',
          'Rotate180',
          'FlipVertical',
          'MirrorDownwardDiagonal',
          'RotateCW',
          'MirrorUpwardDiagonal',
          'RotateCCW',
        ],
        type: 'enum',
        init: true,
      },
      '.BackgroundColor': {
        value: '#000000',
        name: '.BackgroundColor',
        mode: 'RW',
        label: 'Background Color',
        description: 'Background Color',
        type: 'color',
        init: true,
      },
      '.BackgroundOpacity': {
        value: '100',
        name: '.BackgroundOpacity',
        label: 'Background Opacity',
        mode: 'RW',
        description: 'Background Opacity',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Blocked': {
        value: false,
        name: '.Blocked',
        mode: 'RW',
        label: 'Blocked',
        description: 'Blocked',
        type: 'bool',
        init: false,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [
      {
        name: 'Timer',
        uid: 'bb41efbe-b409-4dc3-bd48-cb789740f545',
        default_condition: true,
        data: {
          duration: {
            value: 'Asset Duration',
            label: 'Duration (Seconds)',
            type: 'float',
            dynamic: true,
          },
        },
        description: 'Valid while time since start is less than value',
        icon: 'mdi-timer',
        script: 'default_conditions.playback_timer',
        rejects: ['queue'],
      },
    ],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      'bd3f6b29-2bc5-435a-9080-1a594b78dee2',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  'e46f674c-62b0-4f0e-9f3c-f038567a04ea': {
    id: 3,
    extra_info: {
      nested_template: false,
    },
    uid: 'e46f674c-62b0-4f0e-9f3c-f038567a04ea',
    description: 'A template designed to play live streams (MJPEG, RTSP, etc)',
    name: 'live stream',
    multi: true,
    display_name: 'Live Stream',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-video-wireless',
    src_file: 'LiveStream.vzs',
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.Source': {
        value: null,
        name: '.Source',
        mode: 'RW',
        label: 'Source',
        description: 'Source',
        type: 'asset',
        init: true,
      },
      '.Pause': {
        value: null,
        name: '.Pause',
        label: 'Pause',
        mode: 'W',
        description: 'Pause',
        type: 'trigger',
        init: false,
      },
      '.Play': {
        value: null,
        name: '.Play',
        label: 'Play',
        mode: 'W',
        description: 'Play',
        type: 'trigger',
        init: false,
      },
      '.Audio': {
        value: true,
        name: '.Audio',
        mode: 'RW',
        label: 'Audio',
        description: 'Audio',
        type: 'bool',
        init: true,
      },
      '.Orientation': {
        value: 'Normal',
        name: '.Orientation',
        mode: 'RW',
        label: 'Orientation',
        description: 'Orientation',
        options: [
          'Normal',
          'FlipHorizontal',
          'Rotate180',
          'FlipVertical',
          'MirrorDownwardDiagonal',
          'RotateCW',
          'MirrorUpwardDiagonal',
          'RotateCCW',
        ],
        type: 'enum',
        init: true,
      },
      '.BackgroundColor': {
        value: '#000000',
        name: '.BackgroundColor',
        mode: 'RW',
        label: 'Background Color',
        description: 'Background Color',
        type: 'color',
        init: true,
      },
      '.BackgroundOpacity': {
        value: '100',
        name: '.BackgroundOpacity',
        label: 'Background Opacity',
        mode: 'RW',
        description: 'Background Opacity',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.SizeMode': {
        value: 'Fit',
        name: '.SizeMode',
        mode: 'RW',
        label: 'Size Mode',
        description: 'Size Mode',
        options: ['Stretch', 'Crop', 'Fit'],
        type: 'enum',
        init: true,
      },
      '.Underscan': {
        value: '100',
        name: '.Underscan',
        label: 'Underscan',
        mode: 'RW',
        description: 'Underscan',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Align': {
        value: 'Center',
        name: '.Align',
        mode: 'RW',
        label: 'Align',
        description: 'Align',
        options: ['Center', 'LeftTop', 'RightBottom'],
        type: 'enum',
        init: true,
      },
      '.Blocked': {
        value: false,
        name: '.Blocked',
        mode: 'RW',
        label: 'Blocked',
        description: 'Blocked',
        type: 'bool',
        init: false,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      'c99431fc-6ecf-4065-89cf-bad61228ed10',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  '2e053ae4-8964-4079-a969-da089a94239a': {
    id: 4,
    extra_info: {
      nested_template: false,
    },
    uid: '2e053ae4-8964-4079-a969-da089a94239a',
    description: 'A template designed to show webpages',
    name: 'web',
    multi: true,
    display_name: 'Web',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-web',
    src_file: 'Web.vzs',
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.URL': {
        value: null,
        name: '.URL',
        label: 'URL',
        mode: 'RW',
        description: 'URL',
        type: 'asset',
        asset_tag_filter: 'Text',
        init: true,
      },
      '.Reload': {
        value: null,
        name: '.Reload',
        label: 'Reload',
        mode: 'W',
        description: 'Reload',
        type: 'trigger',
        init: false,
      },
      '.Recover': {
        value: null,
        name: '.Recover',
        label: 'Recover',
        mode: 'W',
        description: 'Recover',
        type: 'trigger',
        init: false,
      },
      '.Finished': {
        value: null,
        name: '.Finished',
        label: 'Finished',
        mode: 'R',
        description: 'Finished',
        type: 'trigger',
        init: false,
      },
      '.DisableSecurity': {
        value: false,
        name: '.DisableSecurity',
        mode: 'RW',
        label: 'Disable Security',
        description: 'Disable Security',
        type: 'bool',
        init: true,
      },
      '.Zoom': {
        value: '100',
        name: '.Zoom',
        label: 'Zoom',
        mode: 'RW',
        description: 'Zoom',
        type: 'slider',
        min: '10',
        max: '500',
        init: true,
      },
      '.Interaction': {
        value: 'None',
        name: '.Interaction',
        mode: 'RW',
        label: 'Interaction',
        description: 'Interaction',
        options: ['None', 'Keyboard', 'Mouse', 'Touch'],
        type: 'enum',
        init: true,
      },
      '.Audio': {
        value: true,
        name: '.Audio',
        mode: 'RW',
        label: 'Audio',
        description: 'Audio',
        type: 'bool',
        init: true,
      },
      '.BackgroundColor': {
        value: '#000000',
        name: '.BackgroundColor',
        mode: 'RW',
        label: 'Background Color',
        description: 'Background Color',
        type: 'color',
        init: true,
      },
      '.BackgroundOpacity': {
        value: '100',
        name: '.BackgroundOpacity',
        label: 'Background Opacity',
        mode: 'RW',
        description: 'Background Opacity',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Blocked': {
        value: false,
        name: '.Blocked',
        mode: 'RW',
        label: 'Blocked',
        description: 'Blocked',
        type: 'bool',
        init: false,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      '23df98ee-ea4c-48df-8db4-f5459afb5803',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  'ca3b2264-81bb-43b8-8d80-3390a0705eaa': {
    id: 5,
    extra_info: {
      nested_template: false,
    },
    uid: 'ca3b2264-81bb-43b8-8d80-3390a0705eaa',
    description: 'A template designed to show video feeds (HDMI, SDI, etc)',
    name: 'video_feed',
    multi: true,
    display_name: 'Video Feed',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-video-input-hdmi',
    src_file: 'VideoFeed.vzs',
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.Source': {
        value: '0',
        name: '.Source',
        mode: 'RW',
        label: 'Source',
        description: 'hint:video_feed',
        type: 'asset',
        asset_tag_filter: 'Video Feed',
        init: true,
      },
      '.SizeMode': {
        value: 'Stretch',
        name: '.SizeMode',
        mode: 'RW',
        label: 'Size Mode',
        description: 'Size Mode',
        options: ['Stretch', 'Crop', 'Fit'],
        type: 'enum',
        init: true,
      },
      '.Underscan': {
        value: '100',
        name: '.Underscan',
        label: 'Underscan',
        mode: 'RW',
        description: 'Underscan',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Align': {
        value: 'Center',
        name: '.Align',
        mode: 'RW',
        label: 'Align',
        description: 'Align',
        options: ['Center', 'LeftTop', 'RightBottom'],
        type: 'enum',
        init: true,
      },
      '.Orientation': {
        value: 'Normal',
        name: '.Orientation',
        mode: 'RW',
        label: 'Orientation',
        description: 'Orientation',
        options: [
          'Normal',
          'FlipHorizontal',
          'Rotate180',
          'FlipVertical',
          'MirrorDownwardDiagonal',
          'RotateCW',
          'MirrorUpwardDiagonal',
          'RotateCCW',
        ],
        type: 'enum',
        init: true,
      },
      '.Blocked': {
        value: false,
        name: '.Blocked',
        mode: 'RW',
        label: 'Blocked',
        description: 'Blocked',
        type: 'bool',
        init: false,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      'f7efa6cf-a6f5-4594-9963-cf0c98cc6f76',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  'f9a14f7f-9626-400f-874a-0bca4a99b53b': {
    id: 6,
    extra_info: {
      nested_template: false,
    },
    uid: 'f9a14f7f-9626-400f-874a-0bca4a99b53b',
    description:
      'A simple template that displays colour with transparency support',
    name: 'colour',
    multi: true,
    display_name: 'Colour',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-palette',
    src_file: 'Colour.vzs',
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.Colour': {
        value: '#ffffff',
        name: '.Colour',
        mode: 'RW',
        label: 'Colour',
        description: 'Colour',
        type: 'color',
        init: true,
      },
      '.Transparent': {
        value: false,
        name: '.Transparent',
        mode: 'RW',
        label: 'Transparent',
        description: 'Transparent',
        type: 'bool',
        init: true,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      '54bd7e13-5deb-498e-93cc-71df45f77cfa',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  '7a40846a-62bc-473d-8729-185694dfd1a4': {
    id: 7,
    extra_info: {
      nested_template: false,
    },
    uid: '7a40846a-62bc-473d-8729-185694dfd1a4',
    description: 'A template designed to show NDI streams',
    name: 'ndi',
    multi: true,
    display_name: 'NDI',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-access-point-network',
    src_file: 'ndi.vzs',
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.Source': {
        value: null,
        name: '.Source',
        mode: 'RW',
        label: 'Source',
        description: 'hint:ndi_source ',
        type: 'asset',
        asset_tag_filter: 'NDI',
        init: true,
      },
      '.LowBandwidth': {
        value: false,
        name: '.LowBandwidth',
        mode: 'RW',
        label: 'Low Bandwidth',
        description: 'Low Bandwidth',
        type: 'bool',
        init: true,
      },
      '.LowLatency': {
        value: false,
        name: '.LowLatency',
        mode: 'RW',
        label: 'Low Latency',
        description: 'Low Latency',
        type: 'bool',
        init: true,
      },
      '.Audio': {
        value: true,
        name: '.Audio',
        mode: 'RW',
        label: 'Audio',
        description: 'Audio',
        type: 'bool',
        init: true,
      },
      '.SizeMode': {
        value: 'Fit',
        name: '.SizeMode',
        mode: 'RW',
        label: 'Size Mode',
        description: 'Size Mode',
        options: ['Stretch', 'Crop', 'Fit'],
        type: 'enum',
        init: true,
      },
      '.Underscan': {
        value: '100',
        name: '.Underscan',
        label: 'Underscan',
        mode: 'RW',
        description: 'Underscan',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.Align': {
        value: 'Center',
        name: '.Align',
        mode: 'RW',
        label: 'Align',
        description: 'Align',
        options: ['Center', 'LeftTop', 'RightBottom'],
        type: 'enum',
        init: true,
      },
      '.Orientation': {
        value: 'Normal',
        name: '.Orientation',
        mode: 'RW',
        label: 'Orientation',
        description: 'Orientation',
        options: [
          'Normal',
          'FlipHorizontal',
          'Rotate180',
          'FlipVertical',
          'MirrorDownwardDiagonal',
          'RotateCW',
          'MirrorUpwardDiagonal',
          'RotateCCW',
        ],
        type: 'enum',
        init: true,
      },
      '.Blocked': {
        value: false,
        name: '.Blocked',
        mode: 'RW',
        label: 'Blocked',
        description: 'Blocked',
        type: 'bool',
        init: false,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      '23fd5ef3-11fd-4bee-b87f-35c4ae28c79f',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  '35427dbf-fb01-40ec-8f70-6dc8ceb0b4b3': {
    id: 8,
    extra_info: {
      nested_template: false,
    },
    uid: '35427dbf-fb01-40ec-8f70-6dc8ceb0b4b3',
    description: 'A template designed to show text',
    name: 'text',
    multi: true,
    display_name: 'Text',
    scene_data: {},
    hidden: false,
    timestamp: 1708595465,
    icon: 'mdi-text-box',
    src_file: 'text.vzs',
    src_scene_data: {
      '.SceneToggle': {
        value: false,
        name: '.SceneToggle',
        mode: 'RW',
        label: 'SceneToggle',
        description: 'SceneToggle',
        type: 'bool',
        init: false,
      },
      '.Text': {
        value: null,
        name: '.Text',
        label: 'Text',
        mode: 'RW',
        description: 'Text',
        type: 'asset',
        asset_tag_filter: 'Text',
        init: true,
      },
      '.Colour': {
        value: '#ffffff',
        name: '.Colour',
        mode: 'RW',
        label: 'Colour',
        description: 'Colour',
        type: 'color',
        init: true,
      },
      '.Opacity': {
        value: '100',
        name: '.Opacity',
        label: 'Opacity',
        mode: 'RW',
        description: 'Opacity',
        type: 'slider',
        min: '0',
        max: '100',
        init: true,
      },
      '.PositionX': {
        value: '0',
        name: '.PositionX',
        label: 'Position X',
        mode: 'RW',
        description: 'Position X',
        type: 'float',
        init: true,
      },
      '.PositionY': {
        value: '0',
        name: '.PositionY',
        label: 'Position Y',
        mode: 'RW',
        description: 'Position Y',
        type: 'float',
        init: true,
      },
      '.Scale': {
        value: '1',
        name: '.Scale',
        label: 'Scale',
        mode: 'RW',
        description: 'Scale',
        type: 'float',
        init: true,
      },
      '.TextAlignment': {
        value: 'Top',
        name: '.TextAlignment',
        mode: 'RW',
        label: 'Text Alignment',
        description: 'Text Alignment',
        options: ['FirstLine', 'LastLine', 'Top', 'Center', 'Bottom'],
        type: 'enum',
        init: true,
      },
      '.LineAlignment': {
        value: 'Near',
        name: '.LineAlignment',
        mode: 'RW',
        label: 'Line Alignment',
        description: 'Line Alignment',
        options: ['Near', 'Center', 'Far', 'Justify', 'Character'],
        type: 'enum',
        init: true,
      },
      '.Width': {
        value: '0',
        name: '.Width',
        label: 'Width',
        mode: 'RW',
        description: 'Width',
        type: 'float',
        init: true,
      },
      '.Height': {
        value: '0',
        name: '.Height',
        label: 'Height',
        mode: 'RW',
        description: 'Height',
        type: 'float',
        init: true,
      },
      '.Blocked': {
        value: false,
        name: '.Blocked',
        mode: 'RW',
        label: 'Blocked',
        description: 'Blocked',
        type: 'bool',
        init: false,
      },
    },
    files: null,
    thumbnail: null,
    status: null,
    default_conditions: [],
    default_triggers: [],
    color: null,
    dynamic_preload: false,
    revision: 0,
    tags: [
      '7f0503bf-0345-4cda-9062-9bdc7103ea71',
      '9ffa7861-5a41-447e-8a1a-0770da8b937f',
    ],
    default_template: true,
  },
  '6d91620e-e732-4226-a8c2-2b93f98bc3bc': {
    id: 9,
    extra_info: {
      nested_template: false,
    },
    uid: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    description: 'CanvasPro Template created from SpinnyCube',
    name: 'spinnycube',
    multi: false,
    display_name: 'SpinnyCube',
    scene_data: {},
    hidden: false,
    timestamp: 1708597361,
    icon: 'mdi-cube-outline',
    src_file: 'SpinnyCube.vza',
    src_scene_data: {
      '.ColorValue': {
        value: '#f62121',
        name: '.ColorValue',
        mode: 'RW',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        type: 'color',
        init: true,
      },
      '.File': {
        value: null,
        name: '.File',
        mode: 'RW',
        label: 'File',
        type: 'asset',
        asset_tag_filter: 'Video',
        init: true,
      },
    },
    files: [],
    thumbnail:
      'data:image/jpeg;base64, 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',
    status: 2,
    default_conditions: [],
    default_triggers: [],
    color: 'rgb(12,6,46)',
    dynamic_preload: false,
    revision: 0,
    tags: [],
    default_template: false,
  },
  'c097b3d1-a65f-415e-bd6c-a45243150f55': {
    id: 10,
    extra_info: {
      nested_template: true,
    },
    uid: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    description: 'CanvasPro Template created from Template4',
    name: 'template4',
    multi: false,
    display_name: 'Template4',
    scene_data: {},
    hidden: false,
    timestamp: 1708597538,
    icon: 'mdi-cube-outline',
    src_file: 'Template4.vza',
    src_scene_data: {
      '$Top Left': {
        name: '$Top Left',
        port_index: 0,
        label: 'Top Left',
        type: 'ventuz_scene_layer',
        value: null,
      },
      '$Top Right': {
        name: '$Top Right',
        port_index: 1,
        label: 'Top Right',
        type: 'ventuz_scene_layer',
        value: null,
      },
      '$Bottom Left': {
        name: '$Bottom Left',
        port_index: 2,
        label: 'Bottom Left',
        type: 'ventuz_scene_layer',
        value: null,
      },
      '$Bottom Right': {
        name: '$Bottom Right',
        port_index: 3,
        label: 'Bottom Right',
        type: 'ventuz_scene_layer',
        value: null,
      },
    },
    files: [],
    thumbnail:
      'data:image/jpeg;base64, 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',
    status: 2,
    default_conditions: [],
    default_triggers: [],
    color: 'rgb(23,23,23)',
    dynamic_preload: false,
    revision: 0,
    tags: [],
    default_template: false,
  },
  '6051f7e0-0e25-415b-bfef-f8bedd3f3d98': {
    id: 11,
    extra_info: {
      nested_template: false,
    },
    uid: '6051f7e0-0e25-415b-bfef-f8bedd3f3d98',
    description: 'CanvasPro Template created from SpinnyCubeWithTime',
    name: 'spinnycubewithtime',
    multi: false,
    display_name: 'SpinnyCubeWithTime',
    scene_data: {},
    hidden: false,
    timestamp: 1708597624,
    icon: 'mdi-cube-outline',
    src_file: 'SpinnyCubeWithTime.vza',
    src_scene_data: {},
    files: ['ventuz://movies/Effect%2010.mov'],
    thumbnail:
      'data:image/jpeg;base64, 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',
    status: 2,
    default_conditions: [],
    default_triggers: [],
    color: 'rgb(16.0,16.0,16.0)',
    dynamic_preload: false,
    revision: 0,
    tags: [],
    default_template: false,
  },
};

const sceneOne = {
  id: 11,
  uid: '75129542-0e04-41a4-9dcd-5d207ca7055c',
  name: 'This One',
  scene_name: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
  ingested: false,
  description: 'CanvasPro Template created from Template4',
  svars: {
    '$Bottom Left': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
    '$Bottom Right': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
    '$Top Left': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
    '$Top Right': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
  },
  conditions: {
    play_conditions: [],
    timestamp: 1708597538,
  },
  priority: 1,
  enabled: true,
  conditions_edited: false,
  domination_mode: 0,
  triggers: [],
  type: 'video_scene',
  did: 26,
  pdid: 4,
  live: false,
  ch_did: 1,
  item_type: 3,
  valid: true,
};

const resultOne = {
  '$Bottom Left': {
    name: '$Bottom Left',
    label: 'Bottom Left',
    keyInherited: false,
    port_index: 2,
    type: 'ventuz_scene_layer',
    value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    scene_data: {
      '$Bottom Left': {
        name: '$Bottom Left',
        label: 'Bottom Left',
        keyInherited: false,
        port_index: 2,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Bottom Right': {
        name: '$Bottom Right',
        label: 'Bottom Right',
        keyInherited: false,
        port_index: 3,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Left': {
        name: '$Top Left',
        label: 'Top Left',
        keyInherited: false,
        port_index: 0,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Right': {
        name: '$Top Right',
        label: 'Top Right',
        keyInherited: false,
        port_index: 1,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
    },
  },
  '$Bottom Right': {
    name: '$Bottom Right',
    label: 'Bottom Right',
    keyInherited: false,
    port_index: 3,
    type: 'ventuz_scene_layer',
    value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    scene_data: {
      '$Bottom Left': {
        name: '$Bottom Left',
        label: 'Bottom Left',
        keyInherited: false,
        port_index: 2,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Bottom Right': {
        name: '$Bottom Right',
        label: 'Bottom Right',
        keyInherited: false,
        port_index: 3,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Left': {
        name: '$Top Left',
        label: 'Top Left',
        keyInherited: false,
        port_index: 0,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Right': {
        name: '$Top Right',
        label: 'Top Right',
        keyInherited: false,
        port_index: 1,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
    },
  },
  '$Top Left': {
    name: '$Top Left',
    label: 'Top Left',
    keyInherited: false,
    port_index: 0,
    type: 'ventuz_scene_layer',
    value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    scene_data: {
      '$Bottom Left': {
        name: '$Bottom Left',
        label: 'Bottom Left',
        keyInherited: false,
        port_index: 2,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Bottom Right': {
        name: '$Bottom Right',
        label: 'Bottom Right',
        keyInherited: false,
        port_index: 3,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Left': {
        name: '$Top Left',
        label: 'Top Left',
        keyInherited: false,
        port_index: 0,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Right': {
        name: '$Top Right',
        label: 'Top Right',
        keyInherited: false,
        port_index: 1,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
    },
  },
  '$Top Right': {
    name: '$Top Right',
    label: 'Top Right',
    keyInherited: false,
    port_index: 1,
    type: 'ventuz_scene_layer',
    value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    scene_data: {
      '$Bottom Left': {
        name: '$Bottom Left',
        label: 'Bottom Left',
        keyInherited: false,
        port_index: 2,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Bottom Right': {
        name: '$Bottom Right',
        label: 'Bottom Right',
        keyInherited: false,
        port_index: 3,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Left': {
        name: '$Top Left',
        label: 'Top Left',
        keyInherited: false,
        port_index: 0,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
      '$Top Right': {
        name: '$Top Right',
        label: 'Top Right',
        keyInherited: false,
        port_index: 1,
        type: 'ventuz_scene_layer',
        value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        scene_data: {
          '.ColorValue': {
            name: '.ColorValue',
            label: 'MaterialM0ColorValue',
            description: 'This is where you can change the colour of the cube!',
            keyInherited: true,
            mode: 'RW',
            init: true,
            type: 'color',
            value: '#f62121',
          },
          '.File': {
            name: '.File',
            label: 'File',
            keyInherited: true,
            mode: 'RW',
            asset_tag_filter: 'Video',
            init: true,
            type: 'asset',
            value: null,
          },
        },
      },
    },
  },
};

const sceneTwo = {
  id: 11,
  uid: '75129542-0e04-41a4-9dcd-5d207ca7055c',
  name: 'This One',
  scene_name: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
  ingested: false,
  description: 'CanvasPro Template created from Template4',
  svars: {
    '$Bottom Left': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {
            '.ColorValue': {
              value: 'scene-two-color-value',
              type: 'color',
            },
            '.File': {
              value: 'scene-two-file-value',
              type: 'asset',
            },
          },
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
    '$Bottom Right': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
    '$Top Left': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
    '$Top Right': {
      scene_data: {
        '$Bottom Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Bottom Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Left': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
        '$Top Right': {
          scene_data: {},
          type: 'ventuz_scene_layer',
          value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
        },
      },
      type: 'ventuz_scene_layer',
      value: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
    },
  },
  conditions: {
    play_conditions: [],
    timestamp: 1708597538,
  },
  priority: 1,
  enabled: true,
  conditions_edited: false,
  domination_mode: 0,
  triggers: [],
  type: 'video_scene',
  did: 26,
  pdid: 4,
  live: false,
  ch_did: 1,
  item_type: 3,
  valid: true,
};

const resultTwo = JSON.parse(JSON.stringify(resultOne));

resultTwo['$Bottom Left'].scene_data['$Bottom Left'].scene_data[
  '.ColorValue'
].value = 'scene-two-color-value';
resultTwo['$Bottom Left'].scene_data['$Bottom Left'].scene_data[
  '.ColorValue'
].keyInherited = false;

resultTwo['$Bottom Left'].scene_data['$Bottom Left'].scene_data['.File'].value =
  'scene-two-file-value';
resultTwo['$Bottom Left'].scene_data['$Bottom Left'].scene_data[
  '.File'
].keyInherited = false;

const resultThree = {
  '$Top Left': {
    name: '$Top Left',
    port_index: 0,
    label: 'Top Left',
    type: 'ventuz_scene_layer',
    value: null,
    keyInherited: true,
  },
  '$Top Right': {
    name: '$Top Right',
    port_index: 1,
    label: 'Top Right',
    type: 'ventuz_scene_layer',
    value: null,
    keyInherited: true,
  },
  '$Bottom Left': {
    name: '$Bottom Left',
    port_index: 2,
    label: 'Bottom Left',
    type: 'ventuz_scene_layer',
    value: null,
    keyInherited: true,
  },
  '$Bottom Right': {
    name: '$Bottom Right',
    port_index: 3,
    label: 'Bottom Right',
    type: 'ventuz_scene_layer',
    value: null,
    keyInherited: true,
  },
};

const templateOne = {
  id: 10,
  extra_info: {
    nested_template: true,
  },
  uid: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
  description: 'CanvasPro Template created from Template4',
  name: 'template4',
  multi: false,
  display_name: 'Template4',
  scene_data: {
    '$Top Left': {
      port_index: 0,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {},
    },
    '$Top Right': {
      port_index: 1,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {},
    },
    '$Bottom Left': {
      port_index: 2,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {},
    },
    '$Bottom Right': {
      port_index: 3,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {},
    },
  },
  hidden: false,
  timestamp: 1708597538,
  icon: 'mdi-cube-outline',
  src_file: 'Template4.vza',
  src_scene_data: {
    '$Top Left': {
      name: '$Top Left',
      port_index: 0,
      label: 'Top Left',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Top Right': {
      name: '$Top Right',
      port_index: 1,
      label: 'Top Right',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Bottom Left': {
      name: '$Bottom Left',
      port_index: 2,
      label: 'Bottom Left',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Bottom Right': {
      name: '$Bottom Right',
      port_index: 3,
      label: 'Bottom Right',
      type: 'ventuz_scene_layer',
      value: null,
    },
  },
  files: [],
  thumbnail:
    'data:image/jpeg;base64, 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',
  status: 2,
  default_conditions: [],
  default_triggers: [],
  color: 'rgb(23,23,23)',
  dynamic_preload: false,
  revision: 0,
  tags: [],
  default_template: false,
};

const resultFour = {
  '$Top Left': {
    name: '$Top Left',
    label: 'Top Left',
    keyInherited: false,
    port_index: 0,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: true,
        mode: 'RW',
        init: true,
        type: 'color',
        value: '#f62121',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: true,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: null,
      },
    },
  },
  '$Top Right': {
    name: '$Top Right',
    label: 'Top Right',
    keyInherited: false,
    port_index: 1,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: true,
        mode: 'RW',
        init: true,
        type: 'color',
        value: '#f62121',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: true,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: null,
      },
    },
  },
  '$Bottom Left': {
    name: '$Bottom Left',
    label: 'Bottom Left',
    keyInherited: false,
    port_index: 2,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: true,
        mode: 'RW',
        init: true,
        type: 'color',
        value: '#f62121',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: true,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: null,
      },
    },
  },
  '$Bottom Right': {
    name: '$Bottom Right',
    label: 'Bottom Right',
    keyInherited: false,
    port_index: 3,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: true,
        mode: 'RW',
        init: true,
        type: 'color',
        value: '#f62121',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: true,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: null,
      },
    },
  },
};

const templateTwo = {
  id: 10,
  extra_info: {
    nested_template: true,
  },
  uid: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
  description: 'CanvasPro Template created from Template4',
  name: 'template4',
  multi: false,
  display_name: 'Template4',
  scene_data: {
    '$Top Left': {
      port_index: 0,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {
        '.ColorValue': { value: 'c111111', type: 'color' },
        '.File': { value: 'f111111', type: 'asset' },
      },
    },
    '$Top Right': {
      port_index: 1,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {
        '.ColorValue': { value: 'c222222', type: 'color' },
        '.File': { value: 'f222222', type: 'asset' },
      },
    },
    '$Bottom Left': {
      port_index: 2,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {
        '.ColorValue': { value: 'c333333', type: 'color' },
        '.File': { value: 'f333333', type: 'asset' },
      },
    },
    '$Bottom Right': {
      port_index: 3,
      type: 'ventuz_scene_layer',
      value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
      scene_data: {
        '.ColorValue': { value: 'c444444', type: 'color' },
        '.File': { value: 'f444444', type: 'asset' },
      },
    },
  },
  hidden: false,
  timestamp: 1708597538,
  icon: 'mdi-cube-outline',
  src_file: 'Template4.vza',
  src_scene_data: {
    '$Top Left': {
      name: '$Top Left',
      port_index: 0,
      label: 'Top Left',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Top Right': {
      name: '$Top Right',
      port_index: 1,
      label: 'Top Right',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Bottom Left': {
      name: '$Bottom Left',
      port_index: 2,
      label: 'Bottom Left',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Bottom Right': {
      name: '$Bottom Right',
      port_index: 3,
      label: 'Bottom Right',
      type: 'ventuz_scene_layer',
      value: null,
    },
  },
  files: [],
  thumbnail:
    'data:image/jpeg;base64, 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',
  status: 2,
  default_conditions: [],
  default_triggers: [],
  color: 'rgb(23,23,23)',
  dynamic_preload: false,
  revision: 0,
  tags: [],
  default_template: false,
};

const resultFive = {
  '$Top Left': {
    name: '$Top Left',
    label: 'Top Left',
    keyInherited: false,
    port_index: 0,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: false,
        mode: 'RW',
        init: true,
        type: 'color',
        value: 'c111111',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: false,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: 'f111111',
      },
    },
  },
  '$Top Right': {
    name: '$Top Right',
    label: 'Top Right',
    keyInherited: false,
    port_index: 1,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: false,
        mode: 'RW',
        init: true,
        type: 'color',
        value: 'c222222',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: false,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: 'f222222',
      },
    },
  },
  '$Bottom Left': {
    name: '$Bottom Left',
    label: 'Bottom Left',
    keyInherited: false,
    port_index: 2,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: false,
        mode: 'RW',
        init: true,
        type: 'color',
        value: 'c333333',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: false,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: 'f333333',
      },
    },
  },
  '$Bottom Right': {
    name: '$Bottom Right',
    label: 'Bottom Right',
    keyInherited: false,
    port_index: 3,
    type: 'ventuz_scene_layer',
    value: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
    scene_data: {
      '.ColorValue': {
        name: '.ColorValue',
        label: 'MaterialM0ColorValue',
        description: 'This is where you can change the colour of the cube!',
        keyInherited: false,
        mode: 'RW',
        init: true,
        type: 'color',
        value: 'c444444',
      },
      '.File': {
        name: '.File',
        label: 'File',
        keyInherited: false,
        mode: 'RW',
        asset_tag_filter: 'Video',
        init: true,
        type: 'asset',
        value: 'f444444',
      },
    },
  },
};

const spinnyCubeScene = {
  id: 22,
  uid: 'ae07e70a-b9e2-42b5-9760-54d74ccd8d14',
  name: 'SpinnyCubeScene',
  scene_name: '6d91620e-e732-4226-a8c2-2b93f98bc3bc',
  ingested: false,
  description: 'SpinnyCube',
  svars: {
    '.ColorValue': {
      value: '#111111',
      type: 'color',
    },
    '.File': {
      value: 'svars-asset-uuid',
      type: 'asset',
    },
  },
  conditions: {
    play_conditions: [],
    timestamp: 1708597538,
  },
  priority: 1,
  enabled: true,
  conditions_edited: false,
  domination_mode: 0,
  triggers: [],
  type: 'video_scene',
  did: 26,
  pdid: 4,
  live: false,
  ch_did: 1,
  item_type: 3,
  valid: true,
};

const spinnyCubeSceneMerge = {
  '.ColorValue': {
    value: '#111111',
    name: '.ColorValue',
    keyInherited: false,
    mode: 'RW',
    label: 'MaterialM0ColorValue',
    description: 'This is where you can change the colour of the cube!',
    type: 'color',
    init: true,
  },
  '.File': {
    value: 'svars-asset-uuid',
    name: '.File',
    keyInherited: false,
    mode: 'RW',
    label: 'File',
    type: 'asset',
    asset_tag_filter: 'Video',
    init: true,
  },
};

export default {
  templates,
  sceneOne,
  resultOne,
  sceneTwo,
  resultTwo,
  resultThree,
  templateOne,
  resultFour,
  templateTwo,
  resultFive,
  spinnyCubeScene,
  spinnyCubeSceneMerge,
};
